@if (error()) {
  <div class="d-flex flex-column align-items-center px-4">
    @if (error()?.icon === '0') {
      <div
        class="ft-icon ft-icon--4 text-primary">
        <svg style="width: 48px; height: 48px;" viewBox="0 0 24 24" id="clock">
          <path
            stroke="currentColor"
            stroke-linejoin="round"
            d="M12 21.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19z"
            fill="none"
            stroke-width="1" />
          <path
            stroke="currentColor"
            d="M11.5 6v6.5l4.5 4"
            fill="none"
            stroke-width="1" />
        </svg>
      </div>
    } @else {
      <ft-icon
        name="warning"
        collection="factoricons-slim"
        class="ft-icon--4 text-primary" />
    }
    <h3 class="m-0">{{ error()?.title }}</h3>
    <p class="text-muted mt-2">{{ error()?.message }}</p>
    @if (error()?.icon === '404') {
      <div class="text-center">
        <button mat-flat-button color="primary" (click)="goHome()" i18n>
          Go home
        </button>
      </div>
    } @else if (error()?.icon === '403') {
      <div class="text-center">
        <button
          mat-flat-button
          color="primary"
          (click)="sessionService.logout()"
          i18n>
          Logout
        </button>
      </div>
    } @else if (error()?.icon === 'unknown') {
      <div class="text-center">
        <button mat-flat-button color="primary" (click)="reload()" i18n>
          Reload
        </button>
      </div>
    }
  </div>
}
